<template>
  <el-dialog
    title="修改论文题目"
    :visible.sync="dialogVisible"
    width="860px"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    custom-class="title-edit-dialog"
  >
    <div v-loading="loading">
      <el-alert
        v-if="detail.titleAuditRemark"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 16px"
        :title="'打回原因：' + detail.titleAuditRemark"
      />

      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="small"
      >
        <!-- <el-form-item label="论文方向">
          <el-input :value="detail.direction" disabled />
        </el-form-item> -->
        <el-form-item label="论文题目" prop="title">
          <div class="topic-type-row">
            <el-radio-group v-model="sTopic" @change="sTopicChange">
              <el-radio label="1">自拟</el-radio>
              <el-radio label="2">题库选择</el-radio>
            </el-radio-group>
            <el-select
              v-show="sTopic == 2"
              v-model="form.questionId"
              placeholder="请选择"
              filterable
              style="margin-left: 10px; width: 300px"
              @change="xqChange"
            >
              <el-option
                v-for="item in topicList"
                :key="item.id"
                :label="item.content"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="title-input-row">
            <el-input
              v-model="form.title"
              placeholder=""
              style="width: calc(100% - 160px)"
              maxlength="1000"
              @input="onTitleInput"
            ></el-input>
            <el-button
              type="primary"
              size="mini"
              class="ml"
              @click="checkTitleExists()"
              >校验题目是否重复</el-button
            >
          </div>
          <!-- <div v-if="topicList.length">
            <span class="red">选题类型提交后不可更改</span>
          </div> -->
        </el-form-item>
        <el-form-item label="英文题目" prop="enName">
          <el-input
            v-model="form.enName"
            placeholder="请输入英文题目"
            maxlength="500"
          />
        </el-form-item>
        <el-form-item v-if="detail.keyword" label="关键词">
          <el-input :value="detail.keyword" />
        </el-form-item>
      </el-form>

      <div class="audit-log-section">
        <div class="audit-log-section__title">题目审核日志</div>
        <el-table
          :data="detail.auditLogs || []"
          border
          size="mini"
          empty-text="暂无审核日志"
          max-height="240"
        >
          <el-table-column
            prop="createTime"
            label="操作时间"
            width="160"
            :formatter="formatTime"
          />
          <el-table-column label="状态" width="100">
            <template slot-scope="{ row }">
              <span :style="row.auditStatus === 0 ? 'color: red;' : ''">
                {{ auditStatusLabel(row.auditStatus) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="operatorName"
            label="操作人"
            width="120"
            :formatter="(_, __, value) => value || '系统'"
          />
          <el-table-column
            prop="auditRemark"
            label="备注"
            min-width="160"
            show-overflow-tooltip
          />
        </el-table>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" :loading="submitting" @click="submit">
        提交修改
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "TitleEditDialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      thesisBatchId: "",
      courseId: null,
      sTopic: "1",
      topicList: [],
      detail: {
        id: null,
        direction: "",
        keyword: "",
        titleAuditRemark: "",
        auditLogs: [],
      },
      form: {
        title: "",
        enName: "",
        questionId: undefined,
      },
      originalTitle: "",
      titleChecked: false,
      checkedTitle: "",
      rules: {
        title: [{ required: true, message: "请输入论文题目", trigger: "blur" }],
        enName: [{ required: true, message: "请输入英文题目", trigger: "blur" }],
      },
      auditStatusMap: {
        0: "打回修改",
        1: "通过",
        2: "已修改",
      },
    };
  },
  methods: {
    open({ thesisProposalId, thesisBatchId, courseId, questionId } = {}) {
      this.thesisBatchId = thesisBatchId || "";
      this.courseId = courseId || null;
      this.dialogVisible = true;
      this.sTopic = questionId ? "2" : "1";
      this.form.questionId = questionId || undefined;
      this.resetTitleCheck();
      this.fetchDetail(thesisProposalId, thesisBatchId);
      this.getTopicList();
    },
    getTopicList() {
      this.$http
        .get("/student/thesisProposal2/thesisProposalTopic", {
          thesisBatchId: this.thesisBatchId,
          courseId: this.courseId,
          questionUse: "no",
        })
        .then((res) => {
          if (res) {
            this.topicList = res || [];
          }
        });
    },
    fetchDetail(thesisProposalId, thesisBatchId) {
      this.loading = true;
      const params = {};
      if (thesisProposalId) params.thesisProposalId = thesisProposalId;
      if (thesisBatchId) params.thesisBatchId = thesisBatchId;
      this.$http
        .get("/student/thesis2/proposal/title/detail", params)
        .then((res) => {
          this.detail = {
            id: res.id,
            direction: res.direction || "",
            keyword: res.keyword || "",
            titleAuditRemark: res.titleAuditRemark || "",
            auditLogs: res.auditLogs || [],
          };
          this.form = {
            ...this.form,
            title: res.title || "",
            enName: res.enName || "",
            questionId: res.questionId || this.form.questionId,
          };
          if (res.questionId) {
            this.sTopic = "2";
          }
          this.originalTitle = (res.title || "").trim();
          if (res.courseId && !this.courseId) {
            this.courseId = res.courseId;
            this.getTopicList();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    auditStatusLabel(status) {
      return this.auditStatusMap[status] != null
        ? this.auditStatusMap[status]
        : status;
    },
    formatTime(row, column, cellValue) {
      if (!cellValue) return "";
      return String(cellValue).replace("T", " ").slice(0, 19);
    },
    onTitleInput() {
      this.resetTitleCheck();
    },
    resetTitleCheck() {
      this.titleChecked = false;
      this.checkedTitle = "";
    },
    sTopicChange() {
      this.$set(this.form, "questionId", undefined);
      this.$set(this.form, "title", "");
      this.resetTitleCheck();
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.validateField("title");
        }
      });
    },
    xqChange(e) {
      if (e) {
        const item = this.topicList.find((v) => v.id == e);
        this.$set(this.form, "title", item ? item.content : "");
      } else {
        this.$set(this.form, "title", "");
      }
      this.resetTitleCheck();
    },
    checkTitleExists() {
      if (!this.form.title || !this.form.title.trim()) {
        this.$message({
          showClose: true,
          message: "请输入题目！",
          type: "error",
        });
        return;
      }
      const trimmedTitle = this.form.title.trim();
      if (trimmedTitle === this.originalTitle) {
        this.titleChecked = true;
        this.checkedTitle = trimmedTitle;
        this.$message({
          showClose: true,
          message: "题目未变更，无需校验。",
          type: "success",
        });
        return;
      }
      this.$http
        .get("/student/thesisProposal2/checkTitleExists", {
          thesisBatchId: this.thesisBatchId,
          title: trimmedTitle,
        })
        .then((res) => {
          if (res) {
            this.titleChecked = true;
            this.checkedTitle = trimmedTitle;
            this.$message({
              showClose: true,
              message: "当前开题报告题目未重复。",
              type: "success",
            });
          } else {
            this.resetTitleCheck();
            this.$message({
              showClose: true,
              message: "当前开题报告题目重复，请更换题目！",
              type: "error",
            });
          }
        });
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        if (this.sTopic == "2" && !this.form.questionId) {
          this.$message({
            showClose: true,
            message: "请选择题库题目！",
            type: "error",
          });
          return;
        }
        const trimmedTitle = (this.form.title || "").trim();
        if (trimmedTitle !== this.originalTitle) {
          if (!this.titleChecked || this.checkedTitle !== trimmedTitle) {
            this.$message({
              showClose: true,
              message: "题目已修改，请先校验题目是否重复，校验通过后才能提交！",
              type: "error",
            });
            return;
          }
        }
        this.submitting = true;
        this.$http
          .put("/student/thesis2/proposal/title", {
            id: this.detail.id,
            title: trimmedTitle,
            enName: (this.form.enName || "").trim(),
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: "题目修改成功！",
              type: "success",
            });
            this.dialogVisible = false;
            this.$emit("success");
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.red {
  color: #f00;
}
.ml {
  margin-left: 10px;
}
.topic-type-row {
  margin-bottom: 8px;
  .el-radio {
    margin-bottom: 0 !important;
  }
}
.title-input-row {
  margin-top: 4px;
}
.audit-log-section {
  margin-top: 8px;
  &__title {
    font-weight: bold;
    margin-bottom: 8px;
    color: #333;
  }
}
</style>
